<template>
  <b-row>
    <b-col>
      <b-button
        @click="$emit('assign', assignmentModes.PARTIALLY)"
        class="w-100"
        :disabled="disabled"
        >Teilweise an mich zuweisen</b-button
      >
    </b-col>
    <b-col>
      <b-button
        :disabled="disabled"
        @click="$emit('assign', assignmentModes.FULLY)"
        class="w-100"
        >Voll an mich zuweisen</b-button
      >
    </b-col>
  </b-row>
</template>

<script>
import { assignmentModeEnum } from "../utils/enums";

export default {
  name: "RequestActionsNurse",
  props: {
    disabled: Boolean
  },
  data() {
    return {
      assignmentModes: assignmentModeEnum
    };
  }
};
</script>

<style scoped></style>
